export default "__VITE_ASSET__BqC_XwYq__"